import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { HashRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { AppRouter } from '../components';
import './App.scss';
import { Toaster, TaskList, EmployeeDocuments, CompanyDocuments, OnboardingDocuments, CompanyPlan, SignatureNotification } from './';
import { getUserRoles } from '../modules';

class App extends Component {
  componentDidMount() {
    this.props.getUserRoles();
  }

  render() {
    return (
      <HashRouter>
        <div className="container pt-4 h-100">
          <div className="position-fixed w-100 toaster-wrap d-flex justify-content-center px-2">
            <Toaster renderLocation="app" classNames={['shadow-sm']} />
          </div>
          <EmployeeDocuments />
          <CompanyDocuments />
          <TaskList />
          <OnboardingDocuments />
          <CompanyPlan />
          <SignatureNotification />
          <AppRouter />
        </div>
      </HashRouter>
    );
  }
}

App.propTypes = {
  getUserRoles: PropTypes.func.isRequired,
};

export default connect(
  () => ({}),
  {
    getUserRoles,
  }
)(hot(module)(App));



// WEBPACK FOOTER //
// ./src/containers/App.jsx